export const monthName = (month,short=false) => {
    const months = ["Yanvar", "Fevral","Mart","Aprel","May","Iyun","Iyul","Avgust","Sentyabr","Oktyabr","Noyabr","Dekabr"];
    const months2 = ["yan", "fev","mar","apr","may","iyun","iyul","avg","sent","okt","noy","dek"];
    if(!month) return "";
    const idx = parseInt(month.slice(5,7))-1;
    if(short) return months2[idx] || "";
    return months[idx] || "";
}
export const monthDays = (month) => {
    return new Date(month?.slice(0,4), month?.slice(5,7), 0).getDate()
}

export const check = (v) => {
    if(!v || typeof(v) == 'undefined'){
        return 0
    }else return v
}

export const seasonMonths = (season) => {
    if(season === 'noveg'){
        return ['Oktyabr','Noyabr','Dekabr','Yanvar','Fevral','Mart'];
    }
    if(season === 'veg'){
        return ['Aprel','May','Iyun','Iyul','Avgust','Sentyabr'];
    }
    return [];
}